import { Editor, NodeViewWrapper } from '@tiptap/react';
import React, { useContext } from 'react';
import DocumentContext from '../../../contexts/DocumentContext.context';
import isDirectNodeSelection from '../../utils/isDirectNodeSelection';
import classNames from 'classnames';

type TProps = {
  node: {
    nodeSize: number;
  };
  editor: Editor;
  updateAttributes: (attributes: any) => void;
  getPos: () => number | undefined;
  selected: boolean;
};

const Component = React.memo(({ editor, selected }: TProps) => {
  const { isEdit } = useContext(DocumentContext);
  const isNodeSelected = isDirectNodeSelection(editor, selected, isEdit);
  return (
    <NodeViewWrapper
      as="div"
      data-drag-handle
      className={classNames('page-break', { selected: isNodeSelected, 'cursor-pointer': isEdit })}
    ></NodeViewWrapper>
  );
});

export default Component;
